export default "__VITE_ASSET__D_FFh_bE__"